<template>
    <div class="wrap workPage">
        <div class="page_title">
            <b>作业看板</b>
        </div>

        <div class="public_box" :class="{ fullscreen: isFullscreen }">
            <!-- 全屏滚动提示 -->
            <div class="scroll-tip" v-if="showScrollTip">
                <el-alert title="提示：5秒后表格将开始自动滚动，按ESC键可退出全屏" type="info" :closable="false" show-icon></el-alert>
            </div>
            <!-- <el-tabs v-model="activeName" @tab-click="handleClick" v-if="0">
                <el-tab-pane label="作业看板" name="first"></el-tab-pane>
                <el-tab-pane label="团队成员" name="second"></el-tab-pane>
            </el-tabs> -->
            <div class="btns" v-if="!isFullscreen">
                <el-button type="primary" @click="(e) => handleClick(false)" v-if="activeName === 'first'">更 新</el-button>
                <el-button type="primary" @click="toggleFullscreen" v-if="activeName === 'first'">{{ isFullscreen ? '退出全屏' : '全屏' }}</el-button>
                <el-button type="primary" plain @click="(e) => handleClick(true)" v-else>返 回</el-button>
                <span class="tips" v-if="dashboardData && dashboardData.length > 0 && activeName === 'first'">看板更新时间：{{ dataUpdateTime }}</span>
            </div>
            <!-- 看板内容 -->
            <div v-if="activeName === 'first'">
                <el-table ref="guTableRef" class="guTable" v-show="totalRows.length > 0 && isFullscreen" :data="totalRows" :cell-class-name="cellClassName" :header-cell-class-name="headerCellClassName" style="width: 100%; margin-bottom: 2px">
                    <el-table-column prop="teamName" label="团队" width="85"> </el-table-column>
                    <el-table-column prop="staffName" label="姓名" width="85"> </el-table-column>
                    <el-table-column prop="pendingCount" label="未决存量" width="100"> </el-table-column>
                    <el-table-column label="当日">
                        <el-table-column prop="todayReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="todayClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="todayCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.todayCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="当周">
                        <el-table-column prop="weekReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="weekClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="weekCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="weekTarget" label="目标" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekTarget ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="weekTargetAchievementRate" label="目标达成率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekTargetAchievementRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="当月">
                        <el-table-column prop="monthReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="monthClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="monthCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="monthTarget" label="目标" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthTarget ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="monthTargetAchievementRate" label="目标达成率">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthTargetAchievementRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="lastMonthCompletionRate" label="上月结案率" width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.lastMonthCompletionRate ?? '--' }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weekCompletionRateRatio" label="周结案率环比" width="140">
                        <template slot-scope="scope">
                            <span class="alignRight">
                                {{ scope.row.weekCompletionRateRatio !== undefined && scope.row.weekCompletionRateRatio !== null ? `${scope.row.weekCompletionRateRatio}%` : '--%' }}
                                <i v-if="scope.row.weekCompletionRateRatio > 0" class="el-icon-top" style="color: #67c23a; margin-left: 2px"></i>
                                <i v-else-if="scope.row.weekCompletionRateRatio < 0" class="el-icon-bottom" style="color: #f56c6c; margin-left: 2px"></i>
                                <i v-else class="el-icon-bottom" style="color: transparent; margin-left: 2px"></i>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="monthCompletionRateRatio" label="月结案率环比" width="140">
                        <template slot-scope="scope">
                            <span class="alignRight">
                                {{ scope.row.monthCompletionRateRatio !== undefined && scope.row.monthCompletionRateRatio !== null ? `${scope.row.monthCompletionRateRatio}%` : '--%' }}
                                <i v-if="scope.row.monthCompletionRateRatio > 0" class="el-icon-top" style="color: #67c23a; margin-left: 2px"></i>
                                <i v-else-if="scope.row.monthCompletionRateRatio < 0" class="el-icon-bottom" style="color: #f56c6c; margin-left: 2px"></i>
                                <i v-else class="el-icon-bottom" style="color: transparent; margin-left: 2px"></i>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 主表格，包含合计行 -->
                <el-table :class="{ zhuTable: 1, gunTable: totalRows.length > 0 && isFullscreen }" :data="dashboardData" :span-method="dashboardSpanMethod" :cell-class-name="cellClassName" :header-cell-class-name="headerCellClassName" :height="isFullscreen ? '860px' : null" style="width: 100%">
                    <el-table-column prop="teamName" label="团队" width="85"> </el-table-column>
                    <el-table-column prop="staffName" label="姓名" width="85"> </el-table-column>
                    <el-table-column prop="pendingCount" label="未决存量" width="100"> </el-table-column>
                    <el-table-column label="当日">
                        <el-table-column prop="todayReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="todayClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="todayCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.todayCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="当周">
                        <el-table-column prop="weekReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="weekClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="weekCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="weekTarget" label="目标" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekTarget ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="weekTargetAchievementRate" label="目标达成率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.weekTargetAchievementRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="当月">
                        <el-table-column prop="monthReport" label="报案" width="85"> </el-table-column>
                        <el-table-column prop="monthClosed" label="结案" width="85"> </el-table-column>
                        <el-table-column prop="monthCompletionRate" label="结案率" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthCompletionRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="monthTarget" label="目标" width="90">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthTarget ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="monthTargetAchievementRate" label="目标达成率">
                            <template slot-scope="scope">
                                <span>{{ scope.row.monthTargetAchievementRate ?? '--' }}%</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column prop="lastMonthCompletionRate" label="上月结案率" width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.lastMonthCompletionRate ?? '--' }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weekCompletionRateRatio" label="周结案率环比" width="140">
                        <template slot-scope="scope">
                            <span class="alignRight">
                                {{ scope.row.weekCompletionRateRatio !== undefined && scope.row.weekCompletionRateRatio !== null ? `${scope.row.weekCompletionRateRatio}%` : '--%' }}
                                <i v-if="scope.row.weekCompletionRateRatio > 0" class="el-icon-top" style="color: #67c23a; margin-left: 2px"></i>
                                <i v-else-if="scope.row.weekCompletionRateRatio < 0" class="el-icon-bottom" style="color: #f56c6c; margin-left: 2px"></i>
                                <i v-else class="el-icon-bottom" style="color: transparent; margin-left: 2px"></i>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="monthCompletionRateRatio" label="月结案率环比" width="140">
                        <template slot-scope="scope">
                            <span class="alignRight">
                                {{ scope.row.monthCompletionRateRatio !== undefined && scope.row.monthCompletionRateRatio !== null ? `${scope.row.monthCompletionRateRatio}%` : '--%' }}
                                <i v-if="scope.row.monthCompletionRateRatio > 0" class="el-icon-top" style="color: #67c23a; margin-left: 2px"></i>
                                <i v-else-if="scope.row.monthCompletionRateRatio < 0" class="el-icon-bottom" style="color: #f56c6c; margin-left: 2px"></i>
                                <i v-else class="el-icon-bottom" style="color: transparent; margin-left: 2px"></i>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 更新成员信息 -->
            <div class="memberInfo" v-if="activeName === 'second'">
                <div class="btns" style="margin-top: -60px">
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </div>
                <el-table :data="memberTable" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                    <el-table-column prop="teamName" label="团队" width="180"> </el-table-column>
                    <el-table-column prop="staffName" label="姓名"> </el-table-column>
                    <el-table-column prop="daxiangJobNo" label="美团大象工号">
                        <template slot-scope="scope">
                            <div v-if="scope.row.daxiangJobNo && scope.row.daxiangJobNo.length > 0 && scope.row.daxiangJobNo != '[]'">
                                <span v-for="(item, index) in JSON.parse(scope.row.daxiangJobNo)" :key="index">{{ item }} <span v-if="scope.row.daxiangJobNo.length > 1">；</span> </span>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tpaJobNo" label="TPA 工号">
                        <template slot-scope="scope">
                            <div v-if="scope.row.tpaJobNo && scope.row.tpaJobNo.length > 0 && scope.row.tpaJobNo != '[]'">
                                <span v-for="(item, index) in JSON.parse(scope.row.tpaJobNo)" :key="index">{{ item }} <span v-if="scope.row.tpaJobNo.length > 1">；</span></span>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weekTarget" label="当周目标">
                        <template slot-scope="scope">
                            <span>{{ scope.row.weekTarget ?? '--' }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="monthTarget" label="当月目标">
                        <template slot-scope="scope">
                            <span>{{ scope.row.monthTarget ?? '--' }}%</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 添加/编辑成员信息 -->
                <el-dialog title="成员信息" :visible.sync="centerDialogVisible" width="30%" center append-to-body>
                    <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px">
                        <el-form-item label="团队" prop="teamName">
                            <el-input v-model="addForm.teamName" placeholder="请输入团队"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名" prop="staffName">
                            <el-input v-model="addForm.staffName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item class="jobNoBox" label="美团大象工号" prop="daxiangJobNoList">
                            <div v-for="(item, index) in addForm.daxiangJobNoList" :key="index" class="work-number-input">
                                <el-input v-model="addForm.daxiangJobNoList[index]" placeholder="请输入美团大象工号" style="width: 80%; margin-right: 10px"> </el-input>
                                <i v-if="addForm.daxiangJobNoList.length > 1" class="delBtnIcon el-icon-remove-outline" @click="removeWorkNumber('daxiangJobNoList', index)"></i>
                            </div>
                            <i class="addBtnIcon el-icon-circle-plus-outline" @click="addWorkNumber('daxiangJobNoList')"></i>
                        </el-form-item>
                        <el-form-item class="jobNoBox" label="TPA 工号" prop="tpaJobNoList">
                            <div v-for="(item, index) in addForm.tpaJobNoList" :key="index" class="work-number-input">
                                <el-input v-model="addForm.tpaJobNoList[index]" placeholder="请输入TPA工号" style="width: 80%; margin-right: 10px"> </el-input>
                                <i v-if="addForm.tpaJobNoList.length > 1" class="delBtnIcon el-icon-remove-outline" @click="removeWorkNumber('tpaJobNoList', index)"></i>
                            </div>
                            <i class="addBtnIcon el-icon-circle-plus-outline" @click="addWorkNumber('tpaJobNoList')"></i>
                        </el-form-item>
                        <el-form-item label="当周目标" prop="weekTarget">
                            <el-input v-model="addForm.weekTarget" placeholder="请输入当周目标" @input="(value) => validateNumberInput('weekTarget', value)">
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="当月目标" prop="monthTarget">
                            <el-input v-model="addForm.monthTarget" placeholder="请输入当月目标" @input="(value) => validateNumberInput('monthTarget', value)">
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-form>

                    <span slot="footer" class="dialog-footer">
                        <el-button @click="(e) => submitForm(false)">取 消</el-button>
                        <el-button type="primary" @click="(e) => submitForm(true)">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'workOrderBoard',
    data() {
        return {
            centerDialogVisible: false,
            workOrderBoard: {},
            activeName: 'first',
            memberForm: {},
            memberTable: [],
            dashboardData: [],
            dataUpdateTime: null,
            totalRows: [],
            isFullscreen: false, // 全屏状态
            showScrollTip: false, // 是否显示滚动提示
            scrollTimer: null, // 滚动定时器
            isScrolling: false, // 是否正在滚动
            addForm: {
                id: '',
                name: '',
                daxiangJobNoList: [''], // 美团大象工号数组
                tpaJobNoList: [''], // TPA工号数组
                weekTarget: '',
                monthTarget: ''
            },
            rules: {
                teamName: [{ required: true, message: '请输入团队', trigger: 'blur' }],
                staffName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                weekTarget: [
                    { message: '请输入当周目标', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback();
                                return;
                            }
                            // 验证数字格式：只允许数字和小数点，最多3位小数
                            const reg = /^\d+(\.\d{0,3})?$/;
                            if (!reg.test(value)) {
                                callback(new Error('请输入正确的数字，最多3位小数'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                monthTarget: [
                    { message: '请输入当月目标', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback();
                                return;
                            }
                            // 验证数字格式：只允许数字和小数点，最多3位小数
                            const reg = /^\d+(\.\d{0,3})?$/;
                            if (!reg.test(value)) {
                                callback(new Error('请输入正确的数字，最多3位小数'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    mounted() {
        this.getDashboard();
        // 监听 ESC 键退出全屏
        document.addEventListener('keydown', this.handleKeydown);
        // 页面加载完成后计算表格高度
        this.$nextTick(() => {
            this.calculateTableHeight();
        });
        // this.getMemberTable();
    },
    beforeDestroy() {
        // 移除事件监听
        document.removeEventListener('keydown', this.handleKeydown);
        // 停止滚动
        this.stopAutoScroll();
    },
    methods: {
        // 切换全屏模式
        toggleFullscreen() {
            this.$set(this, 'isFullscreen', !this.isFullscreen);

            // 显示/隐藏滚动提示
            if (this.isFullscreen) {
                this.showScrollTip = true;
            } else {
                this.showScrollTip = false;
            }

            // return;
            // 延迟执行高度计算，确保DOM已更新
            this.$nextTick(() => {
                this.calculateTableHeight();
                setTimeout(() => {
                    if (this.isFullscreen) {
                        // 进入全屏后开始滚动
                        this.startAutoScroll();
                    } else {
                        // 退出全屏时停止滚动
                        this.stopAutoScroll();
                    }
                }, 5000);
            });
        },

        // 动态计算表格高度并设置margin-top
        calculateTableHeight() {
            // 获取表格元素
            const gunTable = document.querySelector('.gunTable');
            const zhuTable = document.querySelector('.zhuTable');

            // 先处理zhuTable的样式
            if (zhuTable) {
                if (this.isFullscreen) {
                    // 全屏状态下，保持正常样式
                    zhuTable.style.marginTop = '';
                    zhuTable.style.height = '';
                } else {
                    // 非全屏状态下，重置样式确保展示完整
                    zhuTable.style.marginTop = '0px';
                    zhuTable.style.height = 'auto'; // 恢复自适应高度
                    zhuTable.style.overflow = 'visible'; // 确保内容不被裁剪
                    console.log('非全屏模式 - 重置zhuTable样式确保完整展示');
                }
            }

            // 处理gunTable的margin-top
            if (this.$refs.guTableRef && gunTable) {
                if (this.isFullscreen) {
                    // 全屏状态下，设置为-guTableHeight实现重叠效果
                    // 使用$refs获取Element UI表格组件的DOM元素
                    const guTableDom = document.querySelector('.guTable');

                    // 查找表格的header-wrapper和body-wrapper元素，获取实际内容高度
                    const headerWrapper = guTableDom.querySelector('.el-table__header-wrapper');
                    const bodyWrapper = guTableDom.querySelector('.el-table__body-wrapper');

                    // 计算高度：如果找到header和body，使用它们的高度之和，否则使用表格整体高度
                    let guTableHeight;
                    if (headerWrapper && bodyWrapper) {
                        guTableHeight = headerWrapper.offsetHeight + bodyWrapper.offsetHeight;
                    } else {
                        guTableHeight = guTableDom.offsetHeight;
                    }

                    // 获取元素的计算样式
                    const headerStyle = window.getComputedStyle(headerWrapper);

                    // 获取headerWrapper内部元素
                    const headerInner = headerWrapper.querySelector('.el-table__header');
                    if (headerInner) {
                        const headerInnerStyle = window.getComputedStyle(headerInner);
                    }
                    gunTable.style.marginTop = `-${guTableHeight - 20}px`;
                } else {
                    // 非全屏状态下，重置gunTable的margin-top
                    gunTable.style.marginTop = '0px';
                    // console.log('非全屏模式 - 重置gunTable margin-top为0');
                }
            } else {
                // console.warn('未找到guTable或gunTable元素');
            }
        },
        // 监听键盘事件（ESC退出全屏）
        handleKeydown(e) {
            if (e.key === 'Escape' && this.isFullscreen) {
                this.$set(this, 'isFullscreen', false);
                // 退出全屏时，重置表格高度
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.calculateTableHeight();
                    }, 300);
                });
                this.stopAutoScroll();
            }
        },
        // 开始自动滚动
        startAutoScroll() {
            // 先停止之前的滚动
            this.stopAutoScroll();

            // 隐藏滚动提示
            this.showScrollTip = false;

            console.log('开始自动滚动，当前全屏状态:', this.isFullscreen);

            // 获取主表格的滚动容器（在zhuTable类下查找）
            const scrollContainer = document.querySelector('.zhuTable .el-table__body-wrapper');
            if (!scrollContainer) {
                console.warn('未找到滚动容器');
                return;
            }

            // 获取表格行（在zhuTable类下查找）
            const rows = document.querySelectorAll('.zhuTable .el-table__body tr');
            let totalRowsHeight = 0;
            let totalRowCount = 0;

            // 计算所有合计行的总高度
            rows.forEach((row) => {
                const staffNameCell = row.querySelector('td:nth-child(2)');
                if (staffNameCell && staffNameCell.textContent === '合计') {
                    totalRowsHeight += row.offsetHeight;
                    totalRowCount++;
                }
            });

            console.log('滚动容器尺寸 - scrollHeight:', scrollContainer.scrollHeight, 'clientHeight:', scrollContainer.clientHeight);
            console.log('合计行信息 - 高度:', totalRowsHeight, '数量:', totalRowCount);

            // 计算可滚动的最大高度（表格内容高度 - 容器高度）
            const maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;

            // 确保有足够的内容可以滚动
            if (maxScrollTop > totalRowsHeight) {
                this.scrollContainer = scrollContainer;
                this.isScrolling = true;
                // 滚动速度：约8px/秒（原速的一半）
                var pixelsPerSecond = 8;

                // 设置初始滚动位置，确保合计行可见
                this.scrollContainer.scrollTop = 0;
                this.isScrolling = true;

                // 使用 requestAnimationFrame + 时间累加，兼容所有平台和刷新率
                var scrollAccumulator = 0;
                var lastTime = performance.now();
                var self = this;

                function scrollStep(now) {
                    if (!self.isScrolling || !self.scrollContainer) {
                        return;
                    }

                    var delta = now - lastTime;
                    lastTime = now;

                    // 累加亚像素偏移
                    scrollAccumulator += (pixelsPerSecond * delta) / 1000;

                    // 累积满1px时才实际滚动，兼容Windows整数像素截断
                    if (scrollAccumulator >= 1) {
                        var px = Math.floor(scrollAccumulator);
                        scrollAccumulator -= px;
                        self.scrollContainer.scrollTop += px;
                    }

                    // 检查是否到达底部
                    if (self.scrollContainer.scrollTop >= maxScrollTop - 10) {
                        self.scrollContainer.scrollTop = 0;
                    }

                    self.scrollTimer = requestAnimationFrame(scrollStep);
                }

                this.scrollTimer = requestAnimationFrame(scrollStep);

                console.log('自动滚动已启动');
            } else {
                console.warn('表格内容不足，无法滚动');
            }
        },
        // 停止自动滚动并重置滚动位置
        stopAutoScroll() {
            this.isScrolling = false;
            if (this.scrollTimer) {
                cancelAnimationFrame(this.scrollTimer);
                this.scrollTimer = null;
            }

            // 重置滚动位置到顶部
            const scrollContainer = document.querySelector('.zhuTable .el-table__body-wrapper');
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        },
        getDashboard() {
            this.instance.post('/kanban/groupByTeam', {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    // 将嵌套的 team.staffList 结构转换为平铺数据
                    const flattenedData = [];

                    data.data.forEach((team) => {
                        team.staffList.forEach((staff) => {
                            flattenedData.push({
                                ...staff,
                                // 对百分比和目标字段进行四舍五入保留整数
                                monthCompletionRateRatio: staff.monthCompletionRateRatio !== undefined && staff.monthCompletionRateRatio !== null ? Math.round(staff.monthCompletionRateRatio) : staff.monthCompletionRateRatio,
                                weekCompletionRateRatio: staff.weekCompletionRateRatio !== undefined && staff.weekCompletionRateRatio !== null ? Math.round(staff.weekCompletionRateRatio) : staff.weekCompletionRateRatio,
                                todayCompletionRate: staff.todayCompletionRate !== undefined && staff.todayCompletionRate !== null ? Math.round(staff.todayCompletionRate) : staff.todayCompletionRate,
                                weekCompletionRate: staff.weekCompletionRate !== undefined && staff.weekCompletionRate !== null ? Math.round(staff.weekCompletionRate) : staff.weekCompletionRate,
                                weekTarget: staff.weekTarget !== undefined && staff.weekTarget !== null ? Math.round(staff.weekTarget) : staff.weekTarget,
                                weekTargetAchievementRate: staff.weekTargetAchievementRate !== undefined && staff.weekTargetAchievementRate !== null ? Math.round(staff.weekTargetAchievementRate) : staff.weekTargetAchievementRate,
                                monthCompletionRate: staff.monthCompletionRate !== undefined && staff.monthCompletionRate !== null ? Math.round(staff.monthCompletionRate) : staff.monthCompletionRate,
                                monthTarget: staff.monthTarget !== undefined && staff.monthTarget !== null ? Math.round(staff.monthTarget) : staff.monthTarget,
                                monthTargetAchievementRate: staff.monthTargetAchievementRate !== undefined && staff.monthTargetAchievementRate !== null ? Math.round(staff.monthTargetAchievementRate) : staff.monthTargetAchievementRate,
                                lastMonthCompletionRate: staff.lastMonthCompletionRate !== undefined && staff.lastMonthCompletionRate !== null ? Math.round(staff.lastMonthCompletionRate) : staff.lastMonthCompletionRate,
                                teamName: team.teamName,
                                dataUpdateTime: team.dataUpdateTime
                            });
                        });
                    });
                    // 将合计行移到数组前方，保持在同一个表格中
                    const totalRows = flattenedData.filter((row) => row.staffName === '合计');
                    const normalRows = flattenedData.filter((row) => row.staffName !== '合计');
                    this.totalRows = totalRows;
                    if (totalRows.length > 0) {
                        this.calculateTableHeight();
                    }
                    this.dashboardData = [...totalRows, ...normalRows];

                    this.dataUpdateTime = normalRows[0].dataUpdateTime;

                    // 数据更新后，重新计算表格高度
                    this.$nextTick(() => {
                        this.calculateTableHeight();
                    });
                }
            });
        },
        getMemberTable() {
            this.instance.post('/kanban/list', { size: 10, page: 1 }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    // 根据 teamName 字段排序后再赋值
                    this.memberTable = data.data.sort((a, b) => a.teamName.localeCompare(b.teamName));
                }
            });
        },
        // 重置表单数据和校验状态
        resetForm() {
            // 重置表单数据
            this.addForm = {
                id: '',
                name: '',
                daxiangJobNoList: [''], // 美团大象工号数组
                tpaJobNoList: [''], // TPA工号数组
                weekTarget: '',
                monthTarget: ''
            };
            // 清空表单校验状态
            if (this.$refs.addForm) {
                this.$refs.addForm.clearValidate();
            }
        },
        // 数字输入校验方法
        validateNumberInput(field, value, forceUpdate = false) {
            // 移除所有非数字和小数点的字符
            let cleaned = value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            const parts = cleaned.split('.');
            if (parts.length > 2) {
                cleaned = parts[0] + '.' + parts.slice(1).join('');
            }

            // 限制小数位数最多3位
            if (parts[1] && parts[1].length > 3) {
                cleaned = parts[0] + '.' + parts[1].substring(0, 3);
            }

            // 如果值有变化或强制更新，更新表单
            if (cleaned !== value || forceUpdate) {
                this.addForm[field] = cleaned;
                return true; // 返回是否有更新
            }
            return false;
        },
        // 添加工号
        addWorkNumber(type) {
            this.addForm[type].push('');
        },
        // 删除工号
        removeWorkNumber(type, index) {
            if (this.addForm[type].length > 1) {
                this.addForm[type].splice(index, 1);
            }
        },
        submitForm(valid) {
            if (valid) {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.instance.post(`/kanban/${this.addForm.id ? 'update' : 'add'}`, this.addForm).then((res) => {
                            let data = res.data;
                            if (data.code == 1) {
                                // 提交成功后重置表单并关闭对话框
                                console.log(this.addForm.id);
                                this.$message.success(`${this.addForm.id ? '更新' : '添加'}成功`);
                                this.resetForm();
                                this.centerDialogVisible = false;
                                this.getMemberTable();
                            } else {
                                this.$message.error(data.message);
                            }
                        });
                    }
                });
            } else {
                // 点击取消时也重置表单并关闭对话框
                this.resetForm();
                this.centerDialogVisible = false;
            }
        },
        handleClick(backFlag) {
            if (backFlag) {
                this.getDashboard();
                this.activeName = 'first';
            } else {
                this.getMemberTable();
                this.activeName = 'second';
            }
            // return;
            // if (this.activeName == 'first') {
            //     this.getDashboard();
            // } else {
            //     this.getMemberTable();
            // }
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex % 2 === 0) {
                if (columnIndex === 0) {
                    return [1, 2];
                } else if (columnIndex === 1) {
                    return [0, 0];
                }
            }
        },

        // 第一个表格的合并方法（根据 teamName 合并）
        dashboardSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 如果是合计行，不合并第一列
            if (row.staffName === '合计') {
                return { rowspan: 1, colspan: 1 };
            }
            if (columnIndex === 0) {
                // 团队列
                // 向前查找连续的相同团队
                let rowspan = 1;
                for (let i = rowIndex - 1; i >= 0; i--) {
                    if (this.dashboardData[i].teamName === row.teamName) {
                        rowspan++;
                    } else {
                        break;
                    }
                }

                // 如果前面有相同团队，说明已经被合并，隐藏当前行
                if (rowspan > 1) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }

                // 重新计算连续行数（从当前行开始向后计算）
                rowspan = 1;
                for (let i = rowIndex + 1; i < this.dashboardData.length; i++) {
                    if (this.dashboardData[i].teamName === row.teamName) {
                        rowspan++;
                    } else {
                        break;
                    }
                }

                return {
                    rowspan: rowspan,
                    colspan: 1
                };
            }
        },
        cellClassName({ row, column, rowIndex, columnIndex }) {
            if (columnIndex < 2) {
                return 'team-column';
            } else if (columnIndex == 2 || columnIndex == 17) {
                return 'text-column';
            } else if (columnIndex > 2 && columnIndex < 6) {
                return 'text-column day-header';
            } else if (columnIndex > 5 && columnIndex < 11) {
                return 'text-column week-header';
            } else if (columnIndex > 10 && columnIndex < 16) {
                return 'text-column month-header';
            } else {
                return 'team-column';
            }
        },
        headerCellClassName({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                if (columnIndex === 3) {
                    return 'day-header-row';
                } else if (columnIndex === 4) {
                    return 'week-header-row';
                } else if (columnIndex === 5) {
                    return 'month-header-row';
                } else {
                    return 'default-cell';
                }
            } else if (rowIndex === 1) {
                if (columnIndex > 2 && columnIndex < 8) {
                    return 'week-header';
                } else if (columnIndex > 7 && columnIndex < 13) {
                    return 'month-header';
                } else if (columnIndex < 3) {
                    return 'day-header';
                } else {
                    return 'default-cell';
                }
            } else {
                return 'default-cell';
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                // 团队列
                // 计算当前团队连续出现的行数
                let rowspan = 1;

                // 向前查找连续的相同团队
                for (let i = rowIndex - 1; i >= 0; i--) {
                    if (this.memberTable[i].teamName === row.teamName) {
                        rowspan++;
                    } else {
                        break;
                    }
                }

                // 如果前面有相同团队，说明已经被合并，隐藏当前行
                if (rowspan > 1) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }

                // 重新计算连续行数（从当前行开始向后计算）
                rowspan = 1;
                for (let i = rowIndex + 1; i < this.memberTable.length; i++) {
                    if (this.memberTable[i].teamName === row.teamName) {
                        rowspan++;
                    } else {
                        break;
                    }
                }

                return {
                    rowspan: rowspan,
                    colspan: 1
                };
            }
        },
        handleEdit(index, row) {
            // 复制行数据到表单
            this.addForm = {
                id: row.id,
                teamName: row.teamName,
                staffName: row.staffName,
                daxiangJobNoList: row.daxiangJobNo && row.daxiangJobNo.length > 0 ? JSON.parse(row.daxiangJobNo) : [''],
                tpaJobNoList: row.tpaJobNo && row.tpaJobNo.length > 0 ? JSON.parse(row.tpaJobNo) : [''],
                weekTarget: row.weekTarget ? String(row.weekTarget) : '',
                monthTarget: row.monthTarget ? String(row.monthTarget) : ''
            };

            // 对数字字段进行强制校验处理
            this.validateNumberInput('weekTarget', this.addForm.weekTarget, true);
            this.validateNumberInput('monthTarget', this.addForm.monthTarget, true);

            this.centerDialogVisible = true;
        },
        handleDelete(rowIndex, rowItem) {
            this.$confirm('确认删除该条成员信息吗？', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.instance.post(`/kanban/delete`, { id: rowItem.id }).then((res) => {
                    let data = res.data;
                    if (data.code == 1) {
                        this.$message.success('删除成功！');
                        this.getMemberTable();
                    } else {
                        this.$message.error(data.message);
                    }
                });
            });
        },
        handleAdd() {
            // 打开对话框前重置表单
            this.resetForm();
            this.centerDialogVisible = true;
        }
    }
};
</script>
<style lang="less">
/* 全局字体声明 */
@font-face {
    font-family: 'HarmonyOS_Sans_Light'; /* 自定义字体名（后续引用用） */
    src: url('/fonts/HarmonyOS_Sans_Light.ttf') format('truetype');
    font-weight: normal; /* 字体粗细（按需改：bold/600等） */
    font-style: normal; /* 字体样式（normal/italic） */
    font-display: swap; /* 优雅降级：加载完成前用系统字体 */
}
@font-face {
    font-family: 'AlibabaPuHuiTi-2-55-Regular'; /* 自定义字体名（后续引用用） */
    src: url('/fonts/AlibabaPuHuiTi-2-55-Regular.ttf') format('truetype');
    font-weight: normal; /* 字体粗细（按需改：bold/600等） */
    font-style: normal; /* 字体样式（normal/italic） */
    font-display: swap; /* 优雅降级：加载完成前用系统字体 */
}
//

.wrap {
    .page_title {
        margin-bottom: 20px;
    }
    .public_box {
        /* 移除非全屏状态下的固定高度限制，让容器根据内容自动调整高度 */
        overflow: auto;
        .btns {
            margin-bottom: 20px;
        }
    }
    // 全屏模式
    .fullscreen {
        // height: calc(100vh - 10px) !important;
        padding: 0 !important;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        background: #fff;
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
        overflow: hidden;
    }
}
.tips {
    margin-left: 10px;
    color: #ccc;
}
.memberInfo {
    padding: 50rpx;
    .btns {
        text-align: right;
    }
    .work-number-input {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

// 团队列样式
.el-table {
    .default-cell.el-table__cell {
        background: #f1f6fb !important;
        > .cell {
            background: #f1f6fb !important;
            font-family: 'AlibabaPuHuiTi-2-55-Regular';
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: normal !important;
        }
    }
    .day-header-row.el-table__cell,
    .week-header-row.el-table__cell,
    .month-header-row.el-table__cell {
        > .cell {
            font-family: 'AlibabaPuHuiTi-2-55-Regular';
            font-size: 18px;
            letter-spacing: 2px;
            font-weight: normal !important;
        }
    }
    .day-header-row {
        background: #fff7d0 !important;
        .cell {
            background: transparent !important;
        }
    }
    .week-header-row {
        background: #d3f7fb !important;
        .cell {
            background: transparent !important;
        }
    }
    .month-header-row {
        background: #c4cff0 !important;
        .cell {
            background: transparent !important;
        }
    }
    .day-header {
        background: #fff7d096 !important;
        .cell {
            background: transparent !important;
        }
    }
    .week-header {
        background: #d3f7fb96 !important;
        .cell {
            background: transparent !important;
        }
    }
    .month-header {
        background: #c4cff09e !important;
        .cell {
            background: transparent !important;
        }
    }
    .team-column,
    .text-column {
        font-size: 15px;
        letter-spacing: 2px;
        // width: 156px;

        .cell {
            font-family: 'AlibabaSansTC-55';
            font-size: 15px;
            letter-spacing: 2px;
            color: #616161;
            // color: blue;
        }
    }
    .text-column {
        .cell {
            font-family: 'HarmonyOS_Sans_Light';
            font-size: 15px;
            letter-spacing: 2px;
            color: #131313;
            // color: blue;
        }
        .cell:hover {
            color: #ec6657;
        }
    }
}
.jobNoBox {
    position: relative;
    margin-bottom: 0 !important;
    .addBtnIcon,
    .delBtnIcon {
        position: absolute;
        right: 20px;
        top: 8px;
        cursor: pointer;
        color: #409eff;
        font-size: 16px;
    }
}
.work-number-input {
    margin-bottom: 20px;
    position: relative;
    .delBtnIcon {
        color: #f56c6c;
        right: 0px;
        top: 8px;
    }
}
.gunTable {
    width: 100%;
    height: 860px;
    // position: relative;
    // z-index: -1;
    // margin-top 将通过 JavaScript 动态计算
}
.guTable {
    position: relative;
    z-index: 2;
    background: #fff;
    overflow-y: scroll;

    // 确保滚动条显示，覆盖全局隐藏样式
    scrollbar-width: auto !important; /* Firefox - 显示滚动条 */
    -ms-overflow-style: auto !important; /* IE 10+ - 显示滚动条 */

    &::-webkit-scrollbar {
        display: block !important;
        width: 10px !important; /* 设置滚动条宽度 */
        height: 10px !important; /* 设置滚动条高度 */
    }

    &::-webkit-scrollbar-track {
        display: block !important;
        background: #f1f1f1 !important;
    }

    &::-webkit-scrollbar-thumb {
        display: block !important;
        background: #c1c1c1 !important;
        border-radius: 5px !important;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8 !important;
    }

    // 添加最小高度确保滚动条可见
    min-height: 200px;
}

// 全屏滚动提示样式
.scroll-tip {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    width: 80%;
    max-width: 600px;
    animation: fadeIn 0.3s ease-in;
}

// 动画效果
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

// 隐藏表格滚动条并消除占位
// .el-table__body-wrapper {
//     // 核心滚动条隐藏
//     scrollbar-width: none !important; /* Firefox - 隐藏滚动条 */
//     -ms-overflow-style: none !important; /* IE 10+ - 隐藏滚动条 */
//     overflow: -moz-scrollbars-none !important; /* Firefox 旧版 - 隐藏滚动条 */

//     // WebKit浏览器滚动条样式（使用!important确保优先级）
//     &::-webkit-scrollbar {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//         background: transparent !important;
//     }

//     &::-webkit-scrollbar-track {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//         background: transparent !important;
//     }

//     &::-webkit-scrollbar-thumb {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//         background: transparent !important;
//     }

//     &::-webkit-scrollbar-corner {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//         background: transparent !important;
//     }

//     // 确保内容区域占满空间
//     overflow-y: auto !important;
//     overflow-x: auto !important;

//     // 消除Element UI表格可能的额外边距
//     padding-right: 0 !important;
//     padding-bottom: 0 !important;
// }

// // 针对Element UI表格的额外修复
// .el-table {
//     &::-webkit-scrollbar {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//     }
// }

// 修复表格容器的溢出问题
// .el-table-container {
//     overflow: auto !important;
//     scrollbar-width: none !important;

//     &::-webkit-scrollbar {
//         width: 0px !important;
//         height: 0px !important;
//         display: none !important;
//     }
// }
.alignRight {
    display: inline-block;
    width: 100%;
    text-align: right;
    padding-right: 10px;
    color: #616161;
}
.workPage {
    .public_box {
        padding-left: 4px;
        padding-right: 4px;
    }
}
</style>